export default __webpack_public_path__ + "assets/images/Seen-8aeab0cf0c6fad2f7b08092bc1b6ff7f.svg";